/**
 * <tws-video-lightbox> — a trigger that plays a video in a modal <dialog>.
 *
 * Markup: a `[data-lightbox-open]` button, a <dialog> holding the <video>, and
 * a `[data-lightbox-close]` button inside it. Closing (button, Esc or a click
 * on the backdrop) pauses the video, so sound never carries on behind the page.
 */
(() => {
  if (customElements.get('tws-video-lightbox')) return;

  class TwsVideoLightbox extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      this.video = this.dialog?.querySelector('video');
      if (!this.dialog || !this.video) return;

      this.querySelector('[data-lightbox-open]')?.addEventListener('click', () => this.open());
      this.dialog.querySelector('[data-lightbox-close]')?.addEventListener('click', () => this.dialog.close());
      this.dialog.addEventListener('click', (event) => {
        if (event.target === this.dialog) this.dialog.close();
      });
      this.dialog.addEventListener('close', () => this.video.pause());
    }

    open() {
      this.dialog.showModal();
      this.video.play().catch(() => {});
    }
  }

  customElements.define('tws-video-lightbox', TwsVideoLightbox);
})();
